(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["perfume-scent-profile"] && !Shopify.designMode) return;
  try {
    (function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;

  function countUp(el, to, delay) {
    el.textContent = '0';
    setTimeout(function () {
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / 650, 1);
        el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }, delay);
  }

  function open(card) {
    var panel = card.querySelector('[data-sp-open]');
    if (!panel) return;
    card.setAttribute('data-state', 'open');
    panel.hidden = false;
    /* restart CSS animations if re-opened */
    panel.style.animation = 'none'; void panel.offsetWidth; panel.style.animation = '';
    var base = parseFloat(getComputedStyle(panel).getPropertyValue('--t-bf')) || 1.5;
    panel.querySelectorAll('[data-count]').forEach(function (el, i) {
      var to = parseInt(el.getAttribute('data-count'), 10) || 0;
      countUp(el, to, reduced ? 0 : (base * 1000 + 200 + i * 90));
    });
  }

  function close(card) {
    var panel = card.querySelector('[data-sp-open]');
    if (panel) panel.hidden = true;
    card.setAttribute('data-state', 'closed');
  }

  function play(card) {
    if (card.getAttribute('data-state') !== 'closed') return;
    if (reduced) { open(card); return; }
    card.setAttribute('data-state', 'playing');
    setTimeout(function () { open(card); }, 1500);
  }

  function init() {
    document.querySelectorAll('[data-sp]:not(.sp-init)').forEach(function (card) {
      card.classList.add('sp-init');
      var tap = card.querySelector('[data-sp-tap]');
      if (tap) tap.addEventListener('click', function () { play(card); });
      var rp = card.querySelector('[data-sp-replay]');
      if (rp) rp.addEventListener('click', function () { open(card); });
      var cl = card.querySelector('[data-sp-close]');
      if (cl) cl.addEventListener('click', function () { close(card); });
      if (design) open(card);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  if (design) {
    document.addEventListener('shopify:block:select', function (e) {
      var card = e.target.matches('[data-sp]') ? e.target : e.target.querySelector('[data-sp]');
      if (card) open(card);
    });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded",function(){

const trigger=document.querySelector(".units-sold-trigger");

const popup=document.getElementById("soldPopup");

const close=document.querySelector(".sold-popup-close");

if(trigger){

trigger.addEventListener("click",function(){

popup.classList.add("show");

});

}

close.addEventListener("click",function(){

popup.classList.remove("show");

});

popup.addEventListener("click",function(e){

if(e.target===popup){

popup.classList.remove("show");

}

});

});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sold_product"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    var trigger = document.querySelector(".units-sold-trigger");
    var popup = document.getElementById("soldPopup");
    var close = document.querySelector(".sold-popup-close");

    if (trigger && popup) {
      trigger.addEventListener("click", function() {
        popup.classList.add("show");
      });
    }

    if (close && popup) {
      close.addEventListener("click", function() {
        popup.classList.remove("show");
      });
    }

    if (popup) {
      popup.addEventListener("click", function(e) {
        if (e.target === popup) {
          popup.classList.remove("show");
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
